/** Menu flutuante de cores, sobre a seleção (tela L-02).
 *
 * ⚠️ `onMouseDown` com `preventDefault` no container não é firula: sem ele o
 * mousedown do botão limpa a seleção ANTES do click, e o destaque nasce com
 * texto vazio. É o erro clássico deste padrão.
 */
import { CORES } from '@/features/reader/hooks/useHighlights'
import type { CorDestaque } from '@/types/api'

interface HighlightMenuProps {
  /** Âncora em coordenadas normalizadas da página. */
  ancora: { x: number; y: number }
  onEscolher: (cor: CorDestaque) => void | Promise<void>
  onFechar: () => void
  onAnotar?: () => void
}

export function HighlightMenu({ ancora, onEscolher, onFechar, onAnotar }: HighlightMenuProps) {
  return (
    <div
      className="highlight-menu"
      role="toolbar"
      aria-label="Destacar trecho"
      data-testid="highlight-menu"
      style={{ left: `${ancora.x * 100}%`, top: `${ancora.y * 100}%` }}
      onMouseDown={(evento) => evento.preventDefault()}
    >
      {onAnotar && <button type="button" onClick={onAnotar}>Anotar</button>}
      {CORES.map(({ valor, rotulo }) => (
        <button
          key={valor}
          type="button"
          className={`highlight-menu__cor highlight-menu__cor--${valor}`}
          aria-label={`Destacar em ${rotulo}`}
          onClick={() => { void onEscolher(valor) }}
        />
      ))}
      <button
        type="button"
        className="highlight-menu__fechar"
        aria-label="Cancelar destaque"
        onClick={onFechar}
      >
        ✕
      </button>
    </div>
  )
}
